export const GETALL_LOCATIONS = "GETALL_LOCATIONS";
export const SETALL_LOCATIONS = "SETALL_LOCATIONS";
